import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from '../../../service/popup.service';
import { Validators, UntypedFormControl } from '@angular/forms';
import { toggleEditMode } from '../../../../shared/utils';
import { first } from 'rxjs/operators';
import { DataService } from '../../../service/data.service';
import { LookupService } from '../../../service/lookup.service';

@Component({
  selector: 'app-zahlungsart-hv',
  templateUrl: './zahlungsart-hv.component.html',
  styleUrls: ['./zahlungsart-hv.component.scss']
})
export class ZahlungsartHvComponent implements OnInit, OnChanges {

  @Input()
  zahlungsart: UntypedFormControl;

  @Input()
  showZahlungsart = true;

  constructor(public translateService: TranslateService, public popupService: PopupService, public dataService: DataService, public lookupService: LookupService) { }

  static createZahlungsart() {
    return new UntypedFormControl('', Validators.required);
  }

  ngOnInit(): void {
    this.toggleEditMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showZahlungsart && changes.showZahlungsart.currentValue !== changes.showZahlungsart.previousValue) {
      this.toggleEditMode();
    }
  }

  toggleEditMode(): void {
    toggleEditMode(this.zahlungsart, this.showZahlungsart);
  }

  setZahlungsart(zahlungsart: number) {
    this.dataService.zahlungsarten.pipe(first()).toPromise().then((zahlungsarten) => {
      this.zahlungsart.setValue(zahlungsarten.find(x => x.Id === zahlungsart.toString()));
    });
  }

  getZahlungsart(): number {
    return this.zahlungsart.value ? Number(this.zahlungsart.value.Id) : null;
  }
}
